/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./grid-radio.component";
var styles_GridRadioComponent = [];
var RenderType_GridRadioComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_GridRadioComponent, data: {} });
export { RenderType_GridRadioComponent as RenderType_GridRadioComponent };
export function View_GridRadioComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_GridRadioComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-grid-radio", [], null, null, null, View_GridRadioComponent_0, RenderType_GridRadioComponent)), i0.ɵdid(1, 49152, null, 0, i1.GridRadioComponent, [], null, null)], null, null); }
var GridRadioComponentNgFactory = i0.ɵccf("app-grid-radio", i1.GridRadioComponent, View_GridRadioComponent_Host_0, { action: "action", label: "label", icon: "icon", actionsSpanClass: "actionsSpanClass", disable: "disable", isHidden: "isHidden", value: "value" }, {}, []);
export { GridRadioComponentNgFactory as GridRadioComponentNgFactory };
